/** @format */
import { useContext, useEffect } from "react";
import "./index.scss";
import Header from "../core/header";
import AppContext from "../utils/context";
import { USER_ROLES } from "../utils/constants";
import AppSideMenu from "../core/side-menu";
import { Grid } from "@mui/material";
import CustomNavigationMenu from "../core/custom-top-navigation-menu";
import { useLocation } from "react-router-dom";
const MainContainer = ({ children }) => {
  const { userDetails = {} } = useContext(AppContext);
  const location = useLocation();
  useEffect(() => {
    const currentPath = location.pathname;
    if (
      !currentPath.startsWith("/admin/details/") &&
      !currentPath.startsWith("/admin/tickets") &&
      !currentPath.startsWith("/admin/jir")
    ) {
      sessionStorage.removeItem("pastTicketsFilters");
      sessionStorage.removeItem("pastTicketsMainFilters");
      sessionStorage.removeItem("pastTicketsFiltersObject");
    }
    if (!currentPath.startsWith("/admin/float-engine/")) {
      sessionStorage.removeItem("floatEngineFilters");
      sessionStorage.removeItem("floatEngineMainFilters");
    }
  }, [location]);
  return (
    <div className="main-container">
      <Grid container style={{ width: "100%" }}>
        <Grid item md={12} xs={12}>
          <CustomNavigationMenu />
          <div className="main-right-container">{children}</div>
        </Grid>
      </Grid>
    </div>
  );
};

export default MainContainer;
